<div class="file-container position-relative">
  @if (isRequired) {
    @if (label) {
      <label class="file-label text-dark" Asterisk> {{ label }}</label>
    }
  }
  @if (!isRequired) {
    @if (label) {
      <label class="file-label text-dark"> {{ label }}</label>
    }
  }
  @if (!isOnlyPreview) {
    <!-- File Upload -->
    <div class="file-upload-card cursor-pointer position-relative">
      <!-- For Multiple File Upload -->
      @if (isMultipleUpload) {
        <div class="d-flex flex-column justify-content-center align-items-center" (click)="onClickUploadFile()">
          <img src="global-assets/mobi-office-ui/file-upload.svg" class="file-upload-icon" />
          @if (fileUploadInfoMessage) {
            <span class="file-upload-copy">{{ fileUploadInfoMessage }}</span>
          }
          @if (fileUploadSubInfoMessage) {
            <span class="small-text text-light-1-gray">{{ fileUploadSubInfoMessage }}</span>
          }
        </div>
      }

      <!-- For Single File Upload -->
      @if (!isMultipleUpload && !masterFiles.length) {
        <div class="d-flex flex-column justify-content-center align-items-center" (click)="onClickUploadFile()">
          <img src="global-assets/mobi-office-ui/file-upload.svg" class="file-upload-icon" />
          @if (fileUploadInfoMessage) {
            <span class="file-upload-copy">{{ fileUploadInfoMessage }}</span>
          }
          @if (fileUploadSubInfoMessage) {
            <span class="small-text text-light-1-gray">{{ fileUploadSubInfoMessage }}</span>
          }
        </div>
      }
      @if (!isMultipleUpload && masterFiles.length) {
        <div class="single-file-preview d-flex justify-content-center gap-2">
          <ng-container [ngTemplateOutlet]="documentPreview" [ngTemplateOutletContext]="{ document: masterFiles[0] }"></ng-container>
          @if (allowDelete && !isOnlyPreview) {
            <mat-icon class="text-error delete-icon" matTooltip="Delete Document" (click)="onDeleteDocument(masterFiles[0])">cancel</mat-icon>
          }
        </div>
      }
    </div>
    <input class="form-control d-none" type="file" [multiple]="isMultipleUpload" #fileInput (change)="onFileChange($event)" id="formFile" />
    <!-- File Upload Info -->
    <div class="d-flex justify-content-between align-items-center file-upload-info">
      <span class="left__copy">Supported File: {{ fileTypes }}</span>
      <span class="right__copy">File Size: {{ Size || 0 }}MB</span>
    </div>
  }
  <!-- File Preview -->
  @if (masterFiles.length && !isBase64Want && isMultipleUpload) {
    <div class="file-preview-section">
      @for (item of masterFiles; track item) {
        <div class="file-preview-card">
          <div class="left__content">
            <ng-container [ngTemplateOutlet]="documentPreview" [ngTemplateOutletContext]="{ document: item }"></ng-container>
            <div class="file-info">
              @if (item.fileName) {
                <span class="file-info-heading">{{ item.fileName }}</span>
              }
              @if (item.fileSize) {
                <span class="file-info-copy">{{ item.fileSize | filesize }}</span>
              }
            </div>
          </div>
          <div class="right__content">
            @if (allowDelete && !isOnlyPreview) {
              <img src="global-assets/mobi-office-ui/close.svg" (click)="onDeleteDocument(item)" matTooltip="Delete Document" class="delete-icon cursor-pointer" alt="delete-icon" />
            }
          </div>
        </div>
      }
    </div>
  }
  <!-- Loader -->
  @if (showSpinner) {
    <div class="file-loader">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
</div>

<ng-template #documentPreview let-item="document">
  <div class="preview-icon cursor-pointer" matTooltip="Click to view & download">
    @switch (item.fileType) {
      @case (FILE_TYPE.IMAGE) {
        <img [src]="item.fileUrl" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.PDF) {
        <img src="global-assets/mobi-office-ui/file-icons/pdf.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.ZIP) {
        <img src="global-assets/mobi-office-ui/file-icons/zip.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.PPT) {
        <img src="global-assets/mobi-office-ui/file-icons/ppt.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.EXCEL) {
        <img src="global-assets/mobi-office-ui/file-icons/csv.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.VIDEO) {
        <img src="global-assets/mobi-office-ui/file-icons/mp4.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.AUDIO) {
        <img src="global-assets/mobi-office-ui/file-icons/mp3.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.DOC) {
        <img src="global-assets/mobi-office-ui/file-icons/doc.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.TEXT) {
        <img src="global-assets/mobi-office-ui/file-icons/txt.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.RAR) {
        <img src="global-assets/mobi-office-ui/file-icons/rar.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.GZ) {
        <img src="global-assets/mobi-office-ui/file-icons/gz.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.XML) {
        <img src="global-assets/mobi-office-ui/file-icons/xml.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.JSON) {
        <img src="global-assets/mobi-office-ui/file-icons/json-file.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.SQL) {
        <img src="global-assets/mobi-office-ui/file-icons/sql.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
      @default {
        <img src="global-assets/mobi-office-ui/file-icons/doc.png" class="icon" (click)="globalService.openDocumentInNewTab(item.fileUrl)" [alt]="item.fileName" />
      }
    }
  </div>
</ng-template>

<ng-template #fileContainsError>
  <div class="border-one">
    <h1 class="heading text-primary" mat-dialog-title>Error Files</h1>
    <div class="projects-dialog-container shadow-card" mat-dialog-content>
      <div class="row p-0 m-0">
        @for (name of filesContainingError; track name) {
          <div class="p-2 d-flex flex-row justify-content-between">
            <span class="fs-12">{{ name }}</span>
            <div class="text-dark-1-error fs-12 font-bold">File Not Supported</div>
          </div>
        }
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button class="btn-sm-outlined-error me-2" matRipple [mat-dialog-close]="false">Close</button>
    </div>
  </div>
</ng-template>
